var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotVaccine = function SvgShotVaccine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M20.45 5.188c8.975 0 16.237 7.275 16.237 16.237S29.412 37.663 20.45 37.663c-8.963 0-16.238-7.263-16.238-16.225s7.275-16.25 16.238-16.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M26.675 12.9h2.25c.637 0 1.15.512 1.15 1.15v1.737h-4.563V14.05c0-.638.513-1.15 1.15-1.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M15.313 27.15h-3.4v5.712h3.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M13.587 8.912a.566.566 0 0 1-.575-.575v-6.8c0-.325.25-.575.575-.575s.575.25.575.575v6.8c0 .325-.25.575-.575.575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M11.913 8.337h3.4c.637 0 1.15.513 1.15 1.15v1.738H10.75V9.487c0-.637.512-1.15 1.15-1.15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M18.137 11.737v14.825H9.025V11.737c0-.637.512-1.15 1.15-1.15h6.8c.637.063 1.15.575 1.15 1.15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M15.312 11.737v14.825H9.025V11.737c0-.637.512-1.15 1.162-1.15h3.975c.638.063 1.15.575 1.15 1.15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M18.137 19.188v6.287H9.025v-6.288s.575 1.738 3.4 1.738a5.36 5.36 0 0 0 2.825-.775c.9-.45 1.675-.962 2.887-.962"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M7.363 25.412h12.512v.575c0 .963-.775 1.738-1.737 1.738H9.025a1.734 1.734 0 0 1-1.737-1.738v-.575h.075M10.187 32.275h6.8c.638 0 1.15.512 1.15 1.15v1.162H9.025v-1.162c0-.638.512-1.15 1.15-1.15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M11.337 23.162c0 .325-.25.575-.575.575H9.025v-1.15h1.737c.325 0 .575.25.575.575M11.337 18.025c0 .325-.25.575-.575.575H9.025v-1.15h1.737c.325 0 .575.25.575.575M11.337 15.2c0 .325-.25.575-.575.575H9.025v-1.15h1.737c.325 0 .575.25.575.575M33.55 22.975v10.462c0 .638-.513 1.15-1.15 1.15h-9.113c-.637 0-1.15-.512-1.15-1.15V22.975c0-.575.263-1.15.638-1.6l1.537-1.538c.45-.45.638-1.024.638-1.6v-1.35h5.712v1.35c0 .576.25 1.15.638 1.6l1.537 1.538c.45.387.713.962.713 1.6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M30.662 22.975v10.462c0 .638-.512 1.15-1.15 1.15h-6.287c-.638 0-1.15-.512-1.15-1.15V22.975c0-.575.25-1.15.637-1.6l1.538-1.538c.45-.45.637-1.024.637-1.6v-1.35h2.825v1.35c0 .576.25 1.15.638 1.6l1.537 1.538c.575.387.775.962.775 1.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M24.437 15.2h6.8c.325 0 .575.25.575.575v1.15a.573.573 0 0 1-.575.575h-6.8a.573.573 0 0 1-.575-.575v-1.15c0-.325.25-.575.575-.575"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M33.488 24.325H22.124v6.8h11.362z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.987 27.15h-.575v-.575a.573.573 0 0 0-.575-.575.573.573 0 0 0-.575.575v.575h-.575a.566.566 0 0 0-.575.575c0 .325.263.575.575.575h.575v.575c0 .325.263.575.575.575a.58.58 0 0 0 .575-.575V28.3h.575c.325 0 .575-.25.575-.575a.566.566 0 0 0-.575-.575"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M18.138 19.188v6.287h-2.826v-5.263c.838-.512 1.6-1.024 2.826-1.024"
  })));
};
export default SvgShotVaccine;